import { Component, OnInit, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { CommonService } from "../../_services/common.service";
import { CommonProjectDataService } from "../../_services/common-project-data.service";
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { MatDialog } from "@angular/material";
import { AnnouncementDetailComponent } from '../../mnt-master/announcement-detail/announcement-detail.component';
import { LoginClientComponent } from '../../mnt-master/login-client/login-client.component';
import { RegisterClientComponent } from '../../mnt-master/register-client/register-client.component';
import { PublicClientAccountComponent } from '../public-client-account/public-client-account.component';
@Component({
  selector: 'app-public-quote-master-layout',
  templateUrl: './public-quote-master-layout.component.html',
  styleUrls: ['./public-quote-master-layout.component.css']
})
export class PublicQuoteMasterLayoutComponent implements OnInit {
  isHide: boolean = false;
  public announcementData: any = {};
  public builderData: any = {};
  public userDetails: any = {};
  public isClientUserDetails: any = {};
  public loading = true;
  public notFound = false;
  public currentYear: any = ""
  public isFirstLoad = false;
  constructor(private router: Router,
    private activateroute: ActivatedRoute,
    private CommonProjectDataService: CommonProjectDataService,
    private titleService: Title,
    private CommonService: CommonService,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2
  ) {
    this.isClientUserDetails = (localStorage.getItem('clientUserDetails')) ? JSON.parse(localStorage.getItem('clientUserDetails')) : false;
    this.userDetails = (localStorage.getItem('userDetails')) ? JSON.parse(localStorage.getItem('userDetails')) : false;
  }

  ngOnInit() {
    let el = this.renderer.createElement('script');
    this.renderer.setAttribute(el, 'src', 'assets/js/materialize.min.js');
    this.renderer.appendChild(document.body, el);

    this.currentYear = new Date().getFullYear();
    this.isClientUserDetails = (localStorage.getItem('clientUserDetails')) ? JSON.parse(localStorage.getItem('clientUserDetails')) : false;

    if (document.readyState === 'complete') {
      this.isFirstLoad = false;
    } else {
      this.isFirstLoad = true;
    }

    this.getShopDetail();
  }

  builderURLNotFound(error = null) {
    if (localStorage.getItem("userToken") == null) {
      location.reload();
    } else {
      this.notFound = true;
      this.router.navigate(["/builder/not-found"]);
    }
  }

  onActivate(event) {
    window.scroll(0, 0);
  }

  getHelp() {
    window.open("https://theprintlife.freshdesk.com/support/home", "_blank");
  }

  NewQuote() {
    this.CommonProjectDataService.storeQuoteRequest(true);
    this.CommonProjectDataService.storeClientId(null);
    localStorage.removeItem('storeId');
    localStorage.removeItem('pfMainFilters');
    localStorage.setItem('create_new_quote', 'true');
    this.router.navigate(["/builder/quote/order"]);
  }

  getShopDetail = function () {
    if(((Object.keys(this.userDetails).length == 0) || (this.isFirstLoad))) {
      this.CommonService.apiService(
        "GET",
        "quote_builder"
      ).subscribe(
        (response: any) => {
          this.loading = false;
          if (response.status === true && response.data) {
            this.builderData = response.data;
            localStorage.setItem("userID", this.builderData.userDetails.id);
            localStorage.setItem("userDetails", JSON.stringify(this.builderData.userDetails));
            this.setShopDetails();
          } else {
            this.builderURLNotFound();
          }
        },
        err => {
          this.builderURLNotFound(err);
        }
      );
    } else {
      this.setShopDetails();
      this.loading = false;
    }
  }

  setShopDetails() {
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
    this.nextStepForward();
    this.builderData.name = 'Quote Creation | ' + this.userDetails.company_name;
    this.titleService.setTitle(this.builderData.name);
    $("#appPrintLifeFavicon").attr("href", this.userDetails.site_data.site_favicon);
    this.getAnnouncementData();
  }

  nextStepForward() {
    if (Object.keys(this.userDetails).length > 0) {
      const currentPath = this.router.url;
      if (!currentPath.startsWith('/builder/invoice/') && !currentPath.startsWith('/builder/reset-password/')) {
        if (this.isFirstLoad) {
          this.isFirstLoad = false;
          this.NewQuote();
        }
      } else if(currentPath.startsWith('/builder/reset-password/')) {
        this.activeResetPassword();
      }
    } else {
      this.builderURLNotFound();
    }
  
    if (localStorage.getItem('resetPassword') && localStorage.getItem('resetPassword') == 'true') {
      localStorage.removeItem('resetPassword');
      this.openLoginClientDialog();
    }
  }

  trackByFn(index: any, item: any) {
    return index;
  }

  logout() {
    localStorage.removeItem('clientUserDetails');

    this.CommonProjectDataService.storeColorBook([]);
    this.CommonProjectDataService.storeMatrixGroup([]);
    this.NewQuote();
  }

  viewClient = function (clientID) {
    if (clientID && this.userDetails.type == 'Shop') {
      this.router.navigate(["/builder/clients/listing/" + clientID]);
    }
  }

  getAnnouncementData = function () {
    this.loading = true;
    this.CommonService.apiService(
      "GET",
      "announcements/" + localStorage.getItem("userID")
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          this.announcementData = response.data;
        }
      },
      err => {
        this.loading = false;
      }
    );
  };

  toggleFunctionNew(e: MouseEvent) {
    e.stopPropagation();
    this.isHide = !this.isHide; // toggle the notification 
    this.updateNotificationStatus();
  }

  updateNotificationStatus = function () {
    this.loading = true;
    if (this.announcementData.notificationsCount > 0) {
      this.CommonService.apiService(
        "GET",
        "notif_check/" + localStorage.getItem("userID")
      ).subscribe(
        (response: any) => {
          this.loading = false;
          this.announcementData.notificationsCount = 0;
        },
        err => {
          this.loading = false;
        }
      );
    }
  };

  openAnnouncementDialog(announcementId): void {
    let announcementData = this.announcementData.announcementList.find(x => x.announcement_id == announcementId);
    const dialogRef = this.dialog.open(AnnouncementDetailComponent, {
      width: "500px",
      data: {
        announcementData: announcementData
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dismissMessage(result);
      }
    });
  }

  dismissMessage = function (id) {
    let options = {
      id: id,
      shop_id: localStorage.getItem("userID")
    };
    this.CommonService.apiService(
      "POST",
      "announcement/dismiss",
      options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.getAnnouncementData();
        }
      },
      err => {
        this.loading = false;
      }
    );
  }

  openLoginClientDialog(): void {
    const dialogRef = this.dialog.open(LoginClientComponent, {
      width: "900px",
      //maxWidth: "auto",
      disableClose: true,
      data: {
        saveFrom: 'BuilderOrder'
      }
    });

    dialogRef.afterClosed().subscribe(result => {     
      if (result && result != "success") {
        this.isClientUserDetails = (localStorage.getItem('clientUserDetails')) ? JSON.parse(localStorage.getItem('clientUserDetails')) : false;
        this.cdr.detectChanges();
      }
    });
  }

  openRegisterClientDialog(): void {
    const dialogRef = this.dialog.open(RegisterClientComponent, {
      width: "900px",
      //maxWidth: "auto",
      disableClose: true,
      data: {
        saveFrom: 'BuilderOrder'
      }
    });

    dialogRef.afterClosed().subscribe(result => {     
      if (result && result != "success") {
        this.isClientUserDetails = (localStorage.getItem('clientUserDetails')) ? JSON.parse(localStorage.getItem('clientUserDetails')) : false;
        this.cdr.detectChanges();
      }
    });
  }

  openClientAccountDialog(): void {
    const dialogRef = this.dialog.open(PublicClientAccountComponent, {
      width: "500px",
      disableClose: true,
      data: {
        saveFrom: 'BuilderOrder'
      }
    });

    dialogRef.afterClosed().subscribe(result => {     
      if (result && result != "success") {
        this.isClientUserDetails = (localStorage.getItem('clientUserDetails')) ? JSON.parse(localStorage.getItem('clientUserDetails')) : false;
        this.cdr.detectChanges();
      }
    });
  }

  activeResetPassword() {
    this.notFound = true;
  }

}


// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-public-quote/public-quote-master-layout/public-quote-master-layout.component.ts